// import { TareaModel, TaskDocModel } from '../models/TaskModel';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { NotaCuentasCobrarModel } from '../../cobranza/cuentas_por_cobrar/models/CuentasCobrarModel';
import {
  getNoteCuentasCobrarByID,
  updateNoteCuentasCobrar,
} from '../../../service/cuentas_cobrar/CuentasCobrar';

export const useGetNoteCuentasCobrarByID = (id: string, reload: number) => {
  const note: NotaCuentasCobrarModel = {
    id: 0,
    nombre: '',
    descripcion: '',
  };
  const [noteInit, setNoteInit] = useState<NotaCuentasCobrarModel>(note);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getNoteCuentasCobrarByID(id)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setNoteInit(res);
      }
    };
    if (id) {
      fetchPost();
    } else {
      setNoteInit(note);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, reload]);

  return { noteInit };
};

export const useEditNoteCuentasCobrar = () => {
  const [loadingEditNote, setLoadingEditNote] = useState<boolean>(false);
  const history = useHistory();
  const editNote = async (note: NotaCuentasCobrarModel) => {
    setLoadingEditNote(false);
    try {
      await updateNoteCuentasCobrar(note);
      setLoadingEditNote(true);
    } catch (error) {
      history.push('/error/500');
      setLoadingEditNote(false);
    }
  };
  return { editNote, loadingEditNote };
};
